$(document).ready(function() {
  let modal_to_open, modal_to_close;
  $('.modal-trigger-custom').click(function() {
    const modal_to_close = '#' + $(this).parents('.modal').attr('id')
    const modal_to_open  = $(this).attr('href')
    $(modal_to_close).closeModal();
    setTimeout((function () {
      $(modal_to_open).openModal();
    }), 250);
  });

  $('.main-dropdown').change(function() {
    $('.workflow-dropdown').hide();
    $("." + $(this).val().toLowerCase() + "-dropdown").show();
  });

  $('.recipients-field.existing').tagit({
    fieldName: 'recipients[]',
    placeholderText: 'Type custom email here',
    allowSpaces: true,
    caseSensitive: false,
    beforeTagAdded: function(event, ui) {
    },
    afterTagRemoved: function(event, ui) {
    }
  });

  $('.recipients-field.new').tagit({
    fieldName: 'temp_recipients[]',
    allowSpaces: true,
    caseSensitive: false
  });

  $('.tagit-close').off('click');
  $('.recipients-field.new').find('.text-icon').text('+')
  add_existing_tag();
  add_new_tag();

  function add_new_tag() {
    $('.new .workflow-selected-tags').off('click');
    $('.new .workflow-selected-tags').on('click', function(event) {
      $(this).find('.tagit-hidden-field').attr('name', 'recipients[]')
      $(event.target).parents('.edit-tags-container').find('.recipients-field.existing').prepend($(this));
      $('.recipients-field.existing').find('.text-icon').text('×')
      $('.tagit-close').off('click');
      add_existing_tag();
    });
  }

  function add_existing_tag() {
    $('.existing .workflow-selected-tags').off('click');
    $('.existing .workflow-selected-tags').on('click', function(event) {
      $(this).find('.tagit-hidden-field').attr('name', 'temp_recipients[]')
      $(event.target).parents('.edit-tags-container').find('.recipients-field.new').prepend($(this));
      $('.recipients-field.new').find('.text-icon').text('+')
      $('.tagit-close').off('click');
      add_new_tag();
    });
  }
  $(document).on("click", ".group_switch", function() {
      let group_select_container = '.group_select_container_' + $(this).data('container');
      let check_value = $(this).is(':checked');
      $(group_select_container).children().find('.checkbox-custom').prop('checked', check_value);
      $(group_select_container).children().find('.multiselectcs').find('INPUT:checkbox').attr('checked', check_value).parent('LABEL').toggleClass('checked', check_value);
      let groups = [];
      $.each($(group_select_container).children().find('.multiselectcs').find('label'), function (index, value) {
          if($($(value).get(0)).hasClass('checked') && !($($(value).get(0)).hasClass('selectAll'))) {
              groups.push($($(value).find('input').get(0)).val());
          }
      });
      $(group_select_container).children().find('.multiselectcs').find('#groups span').text(groups.length + ' selected')
  });
});
